<template>
  <div>
    <!-- 搜索栏 -->
    <el-form :inline="true" :model="searchForm" class="search-form">
      <el-form-item label="用户ID">
        <el-input v-model="searchForm.userId" placeholder="用户ID" clearable></el-input>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker v-model="searchForm.startTime" type="datetime" placeholder="选择开始时间"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker v-model="searchForm.endTime" type="datetime" placeholder="选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表 -->
    <el-table :data="tableData" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
      <el-table-column prop="grid_company" label="所属电网" width="90"></el-table-column>
      <el-table-column prop="customer_name" label="户名" width="190" align="center"></el-table-column>
      <el-table-column prop="account_number" label="户号" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="avg_monthly_kwh" label="月均电量(kWh)" width="120" align="right"></el-table-column>
      <el-table-column prop="total_last_energy" label="原总电费(元)" width="130" align="right"></el-table-column>
      <el-table-column prop="total_now_energy" label="新总电费(元)" width="130" align="right"></el-table-column>
      <el-table-column prop="company_name" label="报价公司" width="190"></el-table-column>
      <el-table-column prop="contact_name" label="报价人" width="120"></el-table-column>
      <el-table-column prop="contact_number" label="联系电话" width="130"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="160" align="center"></el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button size="small" @click="handleDetail(scope.row.id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;" />

    <!-- 详情弹窗 -->
    <el-dialog title="报价详情" :visible.sync="detailVisible" width="80%" top="5vh">
      <div v-if="detailData">
        <el-descriptions :column="3" border>
          <el-descriptions-item :span="2" label="所属电网">{{ detailData.grid_company }}</el-descriptions-item>
          <el-descriptions-item :span="1" label="所属省份">{{ detailData.province_name }}</el-descriptions-item>
          <el-descriptions-item label="客户名称">{{ detailData.customer_name }}</el-descriptions-item>
          <el-descriptions-item label="户号">{{ detailData.account_number }}</el-descriptions-item>
          <el-descriptions-item label="市场化属性">{{ detailData.ping_price_already == 0 ? "普通代购客户" : "市场化零售客户"
          }}</el-descriptions-item>
          <!-- 原签约价格（已入市用户的原价） -->
          <el-descriptions-item
            v-if="detailData.feng_price_already !== 0 || detailData.ping_price_already !== 0 || detailData.ku_price_already !== 0"
            label="原签约价-丰">{{ detailData.feng_price_already }} 元/kWh</el-descriptions-item>
          <el-descriptions-item
            v-if="detailData.feng_price_already !== 0 || detailData.ping_price_already !== 0 || detailData.ku_price_already !== 0"
            label="原签约价-平">{{ detailData.ping_price_already }} 元/kWh</el-descriptions-item>
          <el-descriptions-item
            v-if="detailData.ping_price_already !== 0"
            label="原签约价-枯">{{ detailData.ku_price_already }} 元/kWh</el-descriptions-item>
          <!-- 原签约价格（已入市用户的原价） -->
          <el-descriptions-item label="新方案价格-丰">{{ detailData.feng_price }} 元/kWh</el-descriptions-item>
          <el-descriptions-item label="新方案价格-平">{{ detailData.ping_price }} 元/kWh</el-descriptions-item>
          <el-descriptions-item label="新方案价格-枯">{{ detailData.ku_price }} 元/kWh</el-descriptions-item>
          <el-descriptions-item label="原总电费">{{ (detailData.total_last_energy || 0).toFixed(2) }}
            元</el-descriptions-item>
          <el-descriptions-item label="新总电费">{{ (detailData.total_now_energy || 0).toFixed(2) }}
            元</el-descriptions-item>
          <el-descriptions-item label="节约电费">{{ ((detailData.total_last_energy || 0) - (detailData.total_now_energy ||
            0)).toFixed(2) }} 元</el-descriptions-item>
          <el-descriptions-item label="月均电量">{{ (detailData.avg_monthly_kwh || 0).toFixed(0) }}
            kWh</el-descriptions-item>
          <el-descriptions-item label="报价文件价格">{{ detailData.report_price }} 元</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ detailData.create_time }}</el-descriptions-item>
          <el-descriptions-item label="报价人">{{ detailData.contact_name }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detailData.contact_number }}</el-descriptions-item>
          <el-descriptions-item label="报价公司" :span="2">{{ detailData.company_name }}</el-descriptions-item>

        </el-descriptions>

        <h3>月度电量明细</h3>
        <el-table :data="detailData.months" border stripe size="middle">
          <el-table-column prop="month_string" label="月份" width="100"></el-table-column>
          <el-table-column prop="jian_count" label="尖峰电量" width="100" align="right"></el-table-column>
          <el-table-column prop="feng_count" label="峰电量" width="100" align="right"></el-table-column>
          <el-table-column prop="ping_count" label="平电量" width="100" align="right"></el-table-column>
          <el-table-column prop="gu_count" label="谷电量" width="100" align="right"></el-table-column>
          <el-table-column prop="fee_total_already" label="原电费" width="120" align="right"></el-table-column>
          <el-table-column prop="fee_total_will" label="新电费" width="120" align="right"></el-table-column>
          <el-table-column prop="fee_decrease" label="节约电费" width="120" align="right"></el-table-column>
          <el-table-column prop="decrease_percentage" label="节约比例" width="100" align="right">
            <template slot-scope="scope">{{ (scope.row.decrease_percentage || 0).toFixed(2) }}%</template>
          </el-table-column>
          <el-table-column prop="is_estimated" label="类型" width="80" align="center">
            <template slot-scope="scope">{{ scope.row.is_estimated ? '预估' : '实际' }}</template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getQuoteList, getQuoteDetail } from '@/api/quote';

export default {
  name: 'QuoteList',
  data() {
    return {
      loading: false,
      searchForm: {
        userId: '',
        startTime: '',
        endTime: ''
      },
      tableData: [],
      total: 0,
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      detailVisible: false,
      detailData: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await getQuoteList({
          pageNo: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          userId: this.searchForm.userId || undefined,
          startTime: this.searchForm.startTime || undefined,
          endTime: this.searchForm.endTime || undefined
        });
        if (res.code === 0) {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg || '加载失败');
        }
      } catch (err) {
        this.$message.error('请求失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    resetSearch() {
      this.searchForm = { userId: '', startTime: '', endTime: '' };
      this.handleSearch();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchData();
    },
    async handleDetail(id) {
      try {
        const res = await getQuoteDetail(id);
        if (res.code === 0) {
          this.detailData = res.data;
          this.detailVisible = true;
        } else {
          this.$message.error(res.msg || '获取详情失败');
        }
      } catch (err) {
        this.$message.error('获取详情失败，请稍后重试');
      }
    }
  }
};
</script>

<style scoped>
.search-form {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/quote/QuoteList.vue